
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The Search Form is a widget which{' '}
  <strong>enables the user to search and retrieve related information</strong>{' '}
  from the database using keywords.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/Search/Search%20Form.jpg" alt="Anatomy of search form" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Text Field`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The input field allows the user to input their search keywords`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The button submits the search input`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul">{`always include a `}<strong parentName="li">{`search button`}</strong></li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul">{`don't use placeholder text in the text field`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`whenever needed, always as part the ECL Site header`}</strong></li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul"></li>
    </ul>
    <h2>{`Notes`}</h2>
    <h3>{`Accessibility`}</h3>
    <ul>
      <li parentName="ul">{`placeholder text in a text field is bad for accessibility - may not be read by screen reading software, and can be problematic for users with a visual impairment`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;